import React from 'react';
import classnames from 'classnames';
import truncate from 'lodash/truncate';
import { baseClassName, mainClassName, omissionClassName } from './constants';
import { useTooltip } from './utils';

var TruncateByLength = function TruncateByLength(_ref) {
  var children = _ref.children,
      threshold = _ref.threshold,
      omission = _ref.omission,
      showTooltip = _ref.showTooltip,
      align = _ref.align,
      className = _ref.className,
      tooltipMaxWidth = _ref.tooltipMaxWidth;
  var isOverflow = false;
  var truncatedText = truncate(children, {
    length: threshold,
    omission: ''
  });

  if (truncatedText !== children) {
    isOverflow = true;
  }

  var truncateContainer = React.createElement("span", {
    className: classnames(className, baseClassName)
  }, React.createElement("span", {
    className: mainClassName
  }, truncatedText), isOverflow && React.createElement("span", {
    className: omissionClassName
  }, omission));
  return useTooltip({
    showTooltip: isOverflow && showTooltip,
    tooltipMaxWidth: tooltipMaxWidth,
    align: align,
    originalContent: children,
    truncatedContent: truncateContainer
  });
};

export default TruncateByLength;